// src/auth/adminPhoneAuthApi.ts
import { apiClient } from "@maat/api-base";
var adminPhoneAuthApi = {
  stats: async (window) => {
    return await apiClient.get("/main/api/admin/phone-auth/stats", { params: { window } });
  },
  health: async () => {
    return await apiClient.get("/main/api/admin/phone-auth/health");
  },
  listTransactions: async (params = {}) => {
    return await apiClient.get("/main/api/admin/phone-auth/transactions", { params });
  },
  getTransaction: async (id) => {
    return await apiClient.get(`/main/api/admin/phone-auth/transactions/${id}`);
  },
  // The callback inbox. ENVELOPE ONLY: there is no `getPayload` here and no
  // endpoint behind one — an undrained row holds the caller's phone number.
  listInbox: async (params = {}) => {
    return await apiClient.get("/main/api/admin/phone-auth/inbox", { params });
  },
  /** Envelope + named vendor fields + the linked transaction — an allow-list, not the body. */
  getInboxDelivery: async (id) => {
    return await apiClient.get(`/main/api/admin/phone-auth/inbox/${id}`);
  },
  inboxStats: async () => {
    return await apiClient.get("/main/api/admin/phone-auth/inbox/stats");
  }
};

export {
  adminPhoneAuthApi
};
